export const SHOW_PARA_DIALOG = 'SHOW_PARA_DIALOG';
export const HIDE_PARA_DIALOG = 'HIDE_PARA_DIALOG';

export const PROFILE_EMAIL_UPDATE_IN_PROGRESS = 'PROFILE_EMAIL_UPDATE_IN_PROGRESS';
export const PROFILE_EMAIL_UPDATE_SUCCESS = 'PROFILE_EMAIL_UPDATE_SUCCESS';
export const PROFILE_EMAIL_UPDATE_ERROR = 'PROFILE_EMAIL_UPDATE_ERROR';
